"use strict";
exports.__esModule = true;
exports.useStyles = exports.drawerWidth = void 0;
var styles_1 = require("@material-ui/core/styles");
exports.drawerWidth = 240;
exports.useStyles = styles_1.makeStyles(function (theme) {
    var _a, _b;
    return ({
        root: {
            display: 'flex'
        },
        toolbar: {
            paddingRight: theme.spacing(3)
        },
        appBar: {
            backgroundColor: theme.palette.primary.main,
            zIndex: theme.zIndex.drawer + 1,
            transition: theme.transitions.create(['width', 'margin'], {
                easing: theme.transitions.easing.sharp,
                duration: theme.transitions.duration.leavingScreen
            })
        },
        appBarShift: {
            marginLeft: exports.drawerWidth,
            width: "calc(100% - " + exports.drawerWidth + "px)",
            transition: theme.transitions.create(['width', 'margin'], {
                easing: theme.transitions.easing.sharp,
                duration: theme.transitions.duration.enteringScreen
            })
        },
        title: {
            color: theme.palette.common.white,
            flexGrow: 1
        },
        search: (_a = {
                position: 'relative',
                borderRadius: theme.shape.borderRadius,
                backgroundColor: styles_1.fade(theme.palette.common.white, 0.15),
                '&:hover': {
                    backgroundColor: styles_1.fade(theme.palette.common.white, 0.25)
                },
                marginLeft: 0,
                width: '100%'
            },
            _a[theme.breakpoints.up('sm')] = {
                marginLeft: theme.spacing(1),
                width: 'auto'
            },
            _a),
        inputRoot: {
            color: 'inherit'
        },
        inputInput: (_b = {
                padding: theme.spacing(1, 1, 1, 7),
                transition: theme.transitions.create('width'),
                width: '100%'
            },
            _b[theme.breakpoints.up('sm')] = {
                width: 120,
                '&:focus': {
                    width: 200
                }
            },
            _b),
        iconButton: {
            color: theme.palette.common.white
        }
    });
});
exports["default"] = exports.useStyles;
